import { showToastrMessage } from 'utils';
import { toastResponseErrors } from 'utils/responseErrorsHelper';

// The daily checkup import only reads these; the rest of what BarnTools
// reports (humidity, dry contacts, onboard equipment) is not consumed.
export const IMPORTED_SENSOR_TYPES = ['Temperature', 'Water'];

export const PUBLIC_API = 'public_api';

export const isPublicApiIntegration = (integration) => integration?.api_version === PUBLIC_API;

// Sites come one organization at a time: a BarnTools credential only ever sees
// its own, and a company can span many.
export const fetchOrganizations = (fetchFromAPI, companyId) => {
  const url = `/admin/companies/${companyId}/barn_tools_integrations/organizations`;

  return fetchFromAPI(url).then(({ resources }) => resources || []);
};

export const fetchSitesForOrg = (fetchFromAPI, companyId, { credentialId, org }) => {
  const query = credentialId ? `credential_id=${credentialId}` : `org=${encodeURIComponent(org)}`;

  return fetchFromAPI(`/admin/companies/${companyId}/barn_tools_integrations/inventory?${query}`)
    .then(({ resources }) => resources || []);
};

// What each field the backend refuses means here. The API answers in terms of
// the device record; these say what to change on the screen.
const FIELD_ERROR_MESSAGES = {
  bt_org_name: 'component.toastr.barnTools.error.field.organization',
  bt_site_id: 'component.toastr.barnTools.error.field.site',
  sensor_serials: 'component.toastr.barnTools.error.field.sensors',
};

// One toast per refused field, so the operator sees what to fix rather than a
// generic failure. `base` errors are already worded by the backend.
export const toastBarnToolsErrors = (error, fallbackKey) => {
  const errors = error?.errors;

  if (!errors || typeof errors !== 'object' || Array.isArray(errors) || !Object.keys(errors).length) {
    showToastrMessage(fallbackKey, 'error');
    return;
  }

  const { base, ...fields } = errors;
  const unexplained = {};

  Object.keys(fields).forEach((field) => {
    if (FIELD_ERROR_MESSAGES[field]) {
      showToastrMessage(FIELD_ERROR_MESSAGES[field], 'error');
    } else {
      unexplained[field] = fields[field];
    }
  });

  if (base) unexplained.base = base;
  if (Object.keys(unexplained).length) toastResponseErrors({ errors: unexplained });
};
